import { $api } from 'services';
import { IUploadFileResponse } from 'types/files';

export class FileApi {

  async uploadImage(file: File) {
    const url = '/api/files/upload';

    const formData = new FormData();
    formData.append('files', file);

    try {
      const { data } = await $api.post<IUploadFileResponse[]>(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return data[0].fileUrl;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }
}

export const fileApi = new FileApi();
